
import { createElement } from "react";
import { initNfeRemoteExportsV2 } from "@moodys/mdc-nanofrontends-loader";

import {
  RemoteExports,
  RemoteExportsKeys,
  RemoteScopes,
} from "@moodys/federated/types";

const moduleFederatedConsumerConfig = {
  name: "MdcShell",
  shared: {
    "react": {
      version: "unknown",
      module: import("react"),
    },
    "react/jsx-runtime": {
      version: "unknown",
      module: import("react/jsx-runtime"),
    },
    "react-dom": {
      version: "unknown",
      module: import("react-dom"),
    },
    "@mui/material": {
      version: "unknown",
      module: import("@mui/material/index.js"),
    },
    "@mui/material/styles": {
      version: "unknown",
      module: import("@mui/material/styles/index.js"),
    },
    "@emotion/react": {
      version: "unknown",
      module: import("@emotion/react"),
    },
    "@emotion/react/jsx-runtime": {
      version: "unknown",
      module: import("@emotion/react/jsx-runtime"),
    },
    "@emotion/styled": {
      version: "unknown",
      module: new Promise((resolve) => {
        import("@emotion/styled").then((module) => resolve(module.default));
      }),
    },
    "@splitsoftware/splitio-react": {
      version: "unknown",
      module: import("@splitsoftware/splitio-react"),
    },
  },
  ...(!!process.env.NANOFRONTENDS_PORT
    ? {
        hmr: {
          enabled: false,
          host: "localhost",
          port: 5008,
          reconnectInterval: 5000
        }
      }
    : {})
};


export const { getFederatedExport, createRoot, withNfe, nfeReady } =
  initNfeRemoteExportsV2(
    moduleFederatedConsumerConfig
  );

const fail = ({ module, submodule, error }) => ({ children, ...rest }) => {
  if (["localhost", "dev", "stg"].includes(process.env.ENV)) {
    console.error({ module, submodule, error });
  }
  return createElement('div', {}, children)
};


export let analytics = getFederatedExport({
  name: "analytics",
  scope: RemoteScopes["analytics"],
  preload: true,
  onLoad: (remoteExports) => {
    analytics = remoteExports?.analytics ?? fail({ module: "analytics", error: remoteExports?.error });
  }
});


export let LetterformSpinner = getFederatedExport({
  name: "LetterformSpinner",
  scope: RemoteScopes["LetterformSpinner"],
  preload: true,
  onLoad: (remoteExports) => {
    LetterformSpinner = remoteExports?.LetterformSpinner ?? fail({ module: "LetterformSpinner", error: remoteExports?.error });
  }
});


export let MoodysLogo = getFederatedExport({
  name: "MoodysLogo",
  scope: RemoteScopes["MoodysLogo"],
  preload: true,
  onLoad: (remoteExports) => {
    MoodysLogo = remoteExports?.MoodysLogo ?? fail({ module: "MoodysLogo", error: remoteExports?.error });
  }
});


export let MoodysThemeProvider = getFederatedExport({
  name: "MoodysThemeProvider",
  scope: RemoteScopes["MoodysThemeProvider"],
  preload: true,
  onLoad: (remoteExports) => {
    MoodysThemeProvider = remoteExports?.MoodysThemeProvider ?? fail({ module: "MoodysThemeProvider", error: remoteExports?.error });
  }
});


export let split = getFederatedExport({
  name: "split",
  scope: RemoteScopes["split"],
  preload: true,
  onLoad: (remoteExports) => {
    split = remoteExports?.split ?? fail({ module: "split", error: remoteExports?.error });
  }
});

